import React, { useEffect, useState } from "react";
import { Model } from "../../models/model";
import { CircleCheck } from "lucide-react";
/* import GoogleDrivePicker from "../reusableUI/google/GoogleDrivePicker"; */

export const Conexiones = () => {
  const [connections, setConnections] = useState([]);

  useEffect(() => {
    getConnections();
  }, []);

  const getConnections = async () => {
    const results = await Model.getAll({
      url: "google/connections/info",
    });
    setConnections(results || []);
  };

  const handleConnection = async (id) => {
    const params = new URLSearchParams({
      return_url: window.location.pathname,
    }).toString();

    const result = await Model.getOne({ url: `google/auth/?${params}` });
    if (result?.url) {
      window.location.href = result.url;
    }
  };

  return (
    <div className="container">
      <div className="row p-contet-title-info-personal">
        <div className="col-12">
          <h3 className="text-start p-title-info-personal">
            Registro de conexiones
          </h3>
        </div>
      </div>

      <div className="mt-4">
        <table className="table">
          <thead>
            <tr>
              <th className="text-left">Servicio</th>
              <th className="text-center">Cuenta</th>
              <th className="text-center">Estado</th>
            </tr>
          </thead>
          <tbody>
            {connections?.map((it) => (
              <tr key={it.id} className="">
                <td className="text-left uppercase">{it?.name || "---"}</td>
                <td className="text-center">{it?.cuenta || "---"}</td>
                <td className="text-center">
                  {it.connected ? (
                    <div className="flex gap-1 justify-center">
                      <CircleCheck color="#12a51c" strokeWidth={2} size={18} />
                      <span className="text-green-600 font-semibold uppercase">
                        Conectado
                      </span>
                    </div>
                  ) : (
                    <button
                      onClick={() => handleConnection(it.id)}
                      className="border p-1 rounded-lg"
                    >
                      Conectar
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
